import React from 'react';
import Icon from './Icon';


function IconClose(props) {
  return (<>
    <Icon width="16" height="16" style={props?.style} className={props?.className}>
      <rect width="20.5223" height="2.10485" transform="matrix(0.707099 -0.707114 0.707099 0.707114 0 14.5117)"/>
      <rect width="20.5223" height="2.10485" transform="matrix(-0.707099 -0.707114 -0.707099 0.707114 16 14.5117)"/>
    </Icon>
  </>);
};

export default IconClose;
